export default "__VITE_ASSET__D$khNvmW__"